import {
    Directive,
    Input,
    TemplateRef,
    ElementRef,
    Renderer2,
    HostListener,
    ViewContainerRef,
  } from '@angular/core';
  
  @Directive({
    selector: '[appTooltip]',
  })
  export class CustomTooltipDirective {
    @Input('appTooltip') tooltipTemplate: TemplateRef<any>;
  
    private tooltipElement: HTMLElement;
    tooltipHideTimeout: any;
    moueseEnteredInTooltipElement: any;
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private viewContainerRef: ViewContainerRef
    ) {
        let ctaInterval = setInterval(() => {
            let ctaBtn = document.querySelector("#upgrade_feature_cta")
            if (ctaBtn) {
                clearInterval(ctaInterval);
                ctaBtn.addEventListener("click", () => {
                    this.hideTooltip();
                })
            }
        }, 500)
    }
  
    // Listen for mouse enter event and show the tooltip
    @HostListener('mouseenter') onMouseEnter(): void {
        this.showTooltip();
    }
    @HostListener('scroll') onScroll(): void {
        this.showTooltip();
    }
  
    // Listen for mouse leave event and hide the tooltip
    @HostListener('mouseleave') onMouseLeave(): void {
        if (!this.tooltipHideTimeout) {
            this.tooltipHideTimeout = setTimeout(() => {
                this.hideTooltip();
                this.tooltipHideTimeout = null;
                this.moueseEnteredInTooltipElement = false;
            }, 300);
            // console.log(39);
        } else {
            this.tooltipHideTimeout = null;
            this.moueseEnteredInTooltipElement = false;
            this.hideTooltip();
            // console.log(44);
        }
    }
  
    // Method to show the tooltip
    private showTooltip(): void {
        if(!this.tooltipTemplate || this.tooltipTemplate == undefined)return
        if (!document.querySelector('.partnerReach-custom-tooltip')) {
            const view = this.viewContainerRef.createEmbeddedView(
                this.tooltipTemplate
            );
            this.tooltipElement = view.rootNodes[0] as HTMLElement;
            this.renderer.addClass(this.tooltipElement, 'partnerReach-custom-tooltip'); // Add any additional styling hereF
            const elPosition = this.el.nativeElement.getBoundingClientRect();
            // Calculate the top position
            let tooltipTop;
            if (elPosition.top < (this.tooltipElement.offsetHeight + 5)) {
                tooltipTop =
                    elPosition.bottom - (this.tooltipElement.offsetHeight - (elPosition.height + 5));
            } else {
                tooltipTop =
                    elPosition.top - (this.tooltipElement.offsetHeight + 5);
            }
            let checkHeight = window.location.href.includes('custom-answers') ? 200 : 140
            if (elPosition.top < checkHeight) tooltipTop = elPosition.top + elPosition.height + 10;
            if((typeof(tooltipTop) == 'number' && Math.sign(tooltipTop) == -1) || (typeof(tooltipTop) != 'number' && Math.sign(parseFloat(tooltipTop)) == -1)){
                tooltipTop = 5
            }
            this.renderer.setStyle(
                this.tooltipElement,
                'top',
                tooltipTop + 'px'
            );
  
            // Calculate the left position to center horizontally
            let tooltipLeft =
                elPosition.left +
                (elPosition.width - this.tooltipElement.offsetWidth) / 2;
            console.log({ elPosition, tooltipElement: this.tooltipElement, tooltipOffsetWidth: this.tooltipElement.offsetWidth, tooltipLeft })
            if (tooltipLeft + 300 > window.innerWidth) {
                tooltipLeft = window.innerWidth - 15 - 300
                console.log(tooltipLeft)
                console.log(elPosition.left - 325)
                console.log(window.innerWidth - tooltipLeft < 300)
                console.log(window.innerWidth - 330)
                // tooltipLeft = elPosition.left - 325
                // if(window.innerWidth - tooltipLeft < 300){
                //     tooltipLeft = window.innerWidth - 330
                // }
            }
            if((typeof(tooltipLeft) == 'number' && Math.sign(tooltipLeft) == -1) || (typeof(tooltipLeft) != 'number' && Math.sign(parseFloat(tooltipLeft)) == -1)){
                tooltipLeft = 5
            }
            this.renderer.setStyle(
                this.tooltipElement,
                'left',
                tooltipLeft + 'px'
            );
  
            // Add an event listener to hide the tooltip on content mouseleave
            this.renderer.listen(this.tooltipElement, 'mouseleave', () => {
                if (this.moueseEnteredInTooltipElement) {
                    this.tooltipHideTimeout = null;
                    this.moueseEnteredInTooltipElement = false;
                    // console.log(87);
                    this.hideTooltip();
                }
            });
  
            // Add an event listener to hide the tooltip on content mouseleave
            this.renderer.listen(this.tooltipElement, 'mouseenter', () => {
                this.moueseEnteredInTooltipElement = true;
                if (this.tooltipHideTimeout) {
                    clearTimeout(this.tooltipHideTimeout);
                }
            });
            document.body.appendChild(this.tooltipElement);
        }
    }
  
    // Method to hide the tooltip
    private hideTooltip(): void {
        if (this.tooltipElement) {
            this.viewContainerRef.clear();
            this.tooltipElement = null;
        }
    }
  }
  